<template>
  <div>
    <teleport
      v-for="modalForm of modalForms"
      :key="`gorgiasModal-${modalForm.uid}`"
      to="body"
    >
      <overlay
        :type="modalForm.type"
        :namespace="`gorgiasModal-${modalForm.uid}`"
        :direction="modalForm.direction"
        block-class="gorgias-modal-form__overlay"
        source="gorgiasModal"
      >
        <!-- eslint-disable vue/no-unused-vars -->
        <template #body="overlay">
          <div class="gorgias-modal-form__container">
            <div :data-gorgias-contact-form-uid="modalForm.uid" />
            <div
              class="gorgias-modal-form__contact-footer"
            >
              <gorgias-modal-footer :uid="modalForm.uid" />
            </div>
          </div>
        </template>
      </overlay>
    </teleport>
  </div>
</template>

<script>

/**
 * Vue: Gorgias modal forms (gorgias-modal-forms)
 * -----------------------------------------------------------------------------
 * Renders Gorgias Forms in Modal when button is clicked.
 * Example:
 * <button
 *  class='gorgias-modal-forms__button'
 *  js-gorgias='btn' data-uid='czg2svy0'>Email us
 * </button>
 * Optional data
 * data-type= STRING - default = "shelf-modal" - The type of overlay
 * data-direction= STRING - default = "up" - The direction of the overlay
 * data-footer = BOOLEAN - default = False - Render the contact footer
 */

import { mapActions } from 'vuex'
import Overlay from '~global/overlay/overlay'

import GorgiasModalFooter from '~async/gorgias-modal-footer/gorgias-modal-footer'

export default {
  name: 'GorgiasModalForms',
  components: {
    Overlay,
    GorgiasModalFooter,
  },

  data() {
    return {
      uids: [],
      types: [],
      directions: [],
      footers: [],
    }
  },

  computed: {
    modalForms() {
      return this.uids.map((uid, index) => ({
        uid,
        type: this.types[index],
        direction: this.directions[index],
        footer: this.footers[index],
      }))
    },
  },

  mounted() {
    this.initializeGorgiasButtons()
    cnvs.EventBus.listen('initialize-gorgias-buttons', this.initializeGorgiasButtons)
  },

  beforeUnmount() {
    cnvs.EventBus.remove('initialize-gorgias-buttons')
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      toggleOverlay: 'overlays/toggle',
    }),

    /**
     * Initialize Gorgias buttons.
     */
    async initializeGorgiasButtons() {
      await this.$nextTick()

      const buttons = document.querySelectorAll('button[js-gorgias="btn"]')
      if (!buttons.length) {
        return
      }

      let shouldLoadScript = false

      buttons.forEach((button) => {
        const uid = button.getAttribute('data-uid')
        const type = button.getAttribute('data-type')
        const direction = button.getAttribute('data-direction')
        const footer = button.getAttribute('data-footer')

        if (!this.uids.includes(uid)) {
          this.uids.push(uid)
        }

        if (type) {
          this.types.push(type)
        } else {
          this.types.push('shelf-modal')
        }

        if (direction) {
          this.directions.push(direction)
        } else {
          this.directions.push('up')
        }

        if (footer) {
          this.footers.push(footer)
        } else {
          this.footers.push('false')
        }

        // Check if the event listener is already attached
        if (!button.hasAttribute('data-gorgias-listener-attached')) {
          button.addEventListener('click', () => this.openOverlay(uid))
          button.setAttribute('data-gorgias-listener-attached', 'true')
          shouldLoadScript = true
        }
      })

      if (shouldLoadScript) {
        this.loadGorgiasScript()
      }
    },

    /**
     * Open Gorgias modal.
     */
    openOverlay(uid) {
      this.toggleOverlay({
        namespace: `gorgiasModal-${uid}`,
        ignoreDismissed: true,
        component: 'gorgias-modal-form',
      })
    },

    /**
     * Load Gorgias script.
     */
    loadGorgiasScript() {
      const script = document.createElement('script')
      script.defer = true
      script.src = 'https://contact.gorgias.help/api/contact-forms/loader.js?v=2'
      document.body.appendChild(script)
    },
  },
}
</script>

<style lang="scss">
@import './gorgias-modal-forms';
</style>
